import { cardSizeFrom } from "@/board/board-utils";
import { defaultCardSizeFactor } from "@/model/Settings";
import type { BoardData } from "@/model/board";
import { MAX_FINISHED_TICKS } from "@/model/board";
import type { FlexType } from "@/model/flexboard";
import { generateId } from "@/utils/string";

import { useArtStore } from "../art";

export function objectivesBoard(): BoardData<"objectives"> {
  return { ...frontendBoard(objectivesBoardId()), type: "objectives" };
}

export function flexBoard(id: string, name: string, flexType: FlexType): BoardData<"flex"> {
  return { ...frontendBoard(id), type: "flex", name, flexType };
}

export function emptyFlexBoard(): BoardData<"flex"> {
  return flexBoard(generateId("2"), "", { id: "", name: "", background: "BLANK" });
}

function frontendBoard(id: string) {
  return {
    id,
    stickyTypes: [],
    almSources: [],
    cards: {},
    maxZ: 0,
    state: { state: "loaded" as const, finishedTicks: MAX_FINISHED_TICKS, loadedAt: 1 },
    cardSize: cardSizeFrom({ factor: defaultCardSizeFactor }),
    selected: {},
    shapes: [],
  };
}

// Mirrored by _objectives_board_id() in piplanningserver's sightline service,
// which resolves this id to the ART's objectives board.
export function objectivesBoardId() {
  return generateId("1", useArtStore().current.id);
}
